import type { CreateUpdateOrderDTO, OrderDTO } from 'ecosystem'
import { createLogger } from 'shared-utils'
import { createError, fetchPropsFactory, storefrontApiCall } from '../../utils/fetching'
import { ORDERS_ENDPOINT } from './constants'

const logger = createLogger('storefront-api/orders')

export async function updateStorefrontOrder(order: CreateUpdateOrderDTO) {
  const props = fetchPropsFactory({
    props: {
      method: 'PUT',
      body: JSON.stringify(order)
    }
  })

  logger.log('updateStorefrontOrder [REQ]', { url: ORDERS_ENDPOINT, order })

  const { data, error } = await storefrontApiCall<OrderDTO>(ORDERS_ENDPOINT, props)

  if (error || !order) {
    logger.error('updateStorefrontOrder [ERROR]', {
      url: ORDERS_ENDPOINT,
      order,
      error
    })
    throw createError(error || 'Update storefront order error')
  }

  logger.log('updateStorefrontOrder [RES]', { url: ORDERS_ENDPOINT, data })

  return data
}
